// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface IErrorDeviceRef {
	id: string | undefined;

	name: string | undefined;

	isCellular: boolean;

	firmwareVersion: string | undefined;

	lastOccurrence: string | undefined;

	count: number;

	$type?: string | undefined;
}
export class ErrorDeviceRef {
	constructor(data?: IErrorDeviceRef) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.lastOccurrence) { this.lastOccurrence = new Date(data.lastOccurrence); }
	}

	id: string | undefined;

	name: string | undefined;

	isCellular: boolean = false;

	firmwareVersion: string | undefined;

	lastOccurrence: Date | undefined = new Date();

	count: number = 0;

	static $type: string = "CoreApi.Data.ErrorDeviceRef, ";
	$type?: string | undefined = ErrorDeviceRef.$type;
}

